// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { UnitService_abstract } from './../abstract/SagaSchema/UnitService_abstract';
export class UnitService extends UnitService_abstract {}
